import { useEffect, useState } from "react";
import { APISettings } from "../config/ApiSettings";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { getEnvironmentVariables } from "../features/state/StateEnvironment-slice";

const useConfig = () => {
  const [config, setConfig] = useState<any>();
  const dispatch = useAppDispatch();
  const envValues: any = useAppSelector((state) => state.environment.values);

  useEffect(() => {
    if (!envValues) {
      dispatch(getEnvironmentVariables(window.location.hostname));
    }

    const sessionConfig = envValues;
    if (sessionConfig) {
      setConfig(sessionConfig);
      return;
    }

    sessionStorage.setItem("config", JSON.stringify(envValues));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [envValues]);

  return [config];
};

export default useConfig;